import {useShallow} from 'zustand/react/shallow';

import {useQuestionTranslationStore} from './TranslationSection/TranslationStore';
import {itemAreaText} from './TranslationSection/TranslationText';

export type ItemAreaCopy = typeof itemAreaText;

export const englishItemAreaCopy: ItemAreaCopy = {
  itemBankInstruction: 'Select or drag an item to move it to the correct answer.',
  orderingInstruction: 'Select or drag an item to move it to the correct position.',
  answerArea: 'Answer area',
  yourOrder: 'Your order'
};

/** The copy for instructions and answer areas, in Spanish while the student has the question's translation on. */
export const useItemAreaCopy = (): ItemAreaCopy => {
  const showTranslations = useQuestionTranslationStore(
    useShallow((state) => state.showTranslations && state.translationSettings.question)
  );
  return showTranslations ? itemAreaText : englishItemAreaCopy;
};
